import axios from 'axios';

// Base API URL - get from environment or use relative for proxy
const API_URL = process.env.REACT_APP_API_URL || '';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Add these timeout and proxy-related settings
  timeout: 30000,
  withCredentials: true,
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Convert error response to standardized format
    if (error.response && error.response.data) {
      // If the response already has our standard error format, use it
      if (typeof error.response.data === 'object' && error.response.data.message) {
        error.standardizedError = true;
      } 
      // Handle older error format with 'detail' field
      else if (typeof error.response.data === 'object' && error.response.data.detail) {
        error.message = error.response.data.detail;
      }
      // Handle string error message
      else if (typeof error.response.data === 'string') {
        error.message = error.response.data;
      }
    }

    // Add HTTP status code to the error for easier handling in UI
    if (error.response) {
      error.statusCode = error.response.status;
    }

    // Add user-friendly messages based on HTTP status codes
    if (error.statusCode && !error.standardizedError) {
      switch (error.statusCode) {
        case 400:
          error.userMessage = 'The request was invalid. Please check your input and try again.';
          break;
        case 401:
          error.userMessage = 'You need to be logged in to perform this action.';
          break;
        case 403:
          error.userMessage = 'You don\'t have permission to access this resource.';
          break;
        case 404:
          error.userMessage = 'The requested resource was not found.';
          break;
        case 422:
          error.userMessage = 'Validation error. Please check your input.';
          break;
        case 500:
          error.userMessage = 'An unexpected server error occurred. Please try again later.';
          break;
        default:
          error.userMessage = 'An error occurred while processing your request.';
      }
    }

    // Handle authentication errors
    if (error.statusCode === 401) {
      // Clear authentication if token is invalid/expired
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login?session_expired=true';
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;